import { ObjectBuilder, Image3D, MeshUtils, Rectangle3D, ScrollViewer3D } from "@dreamcam/babylon-tools";
import { Env } from "../../settings/Env";
import { ScrollHandler } from "../ScrollHandler";
import { MeshName } from "../MeshName";
import { XRInputHelper } from "../XRInputHelper";
import { Container } from "@babylonjs/gui/2D/controls/container.js";
import { StackPanel } from "@babylonjs/gui/2D/controls/stackPanel.js";
import { text } from "../../TextResources";
export class VideoClipMenuRecommended {
    get isFocused() { return this._isFocused; }
    constructor(mesh2d, callbacks) {
        this._videoClip = null;
        this._hasRecommendedVideoClips = false;
        this._isFocused = false;
        this._mesh2d = mesh2d;
        this._callbacks = callbacks;
        const menu = Env.videoClip.menu;
        const rp = menu.recommendedVideosPanel;
        this._scrollHandler = new ScrollHandler([MeshName.videoMenuRecommendedVideosPanel], this._mesh2d.m2px(rp.scrollView.speed), v => {
            const innerWidth = this._scrollViewer.children[0].widthInPixels;
            const outerWidth = this._scrollViewer.widthInPixels;
            const clamp01 = (value) => Math.max(Math.min(value, 1), 0);
            this._scrollViewer.horizontalValue =
                clamp01(this._scrollViewer.horizontalValue + v / (innerWidth - outerWidth));
        });
        const pointerAddon = XRInputHelper.addPointerAddon(this._mesh2d.mesh);
        pointerAddon.onPointerEnter.add(() => {
            this._isFocused = true;
        });
        pointerAddon.onPointerOut.add(() => {
            this._isFocused = false;
            this._scrollHandler.stopScroll();
            this._mesh2d.notifyChildrenOnPointerOut();
        });
        const backgroundPanel = new Rectangle3D("videoClipMenuRecommendedPanelContainer");
        backgroundPanel.widthInPixels = this._mesh2d.m2px(menu.width);
        backgroundPanel.heightInPixels = this._mesh2d.m2px(rp.height);
        backgroundPanel.cornerRadius = this._mesh2d.m2px(menu.cornerRadius);
        backgroundPanel.background = menu.background;
        backgroundPanel.thickness = 0;
        this._mesh2d.texture.addControl(backgroundPanel);
        this._titleTextBlock = ObjectBuilder.createTextBlock3D(this._mesh2d, "videoClipMenuRecommendedTitleTextBlock", text.videoClip_recommended_title, rp.title);
        backgroundPanel.addControl(this._titleTextBlock);
        this._scrollViewer = new ScrollViewer3D("videoClipMenuRecommendedScrollViewer");
        this._scrollViewer.verticalAlignment = ScrollViewer3D.VERTICAL_ALIGNMENT_BOTTOM;
        this._scrollViewer.heightInPixels = this._mesh2d.m2px(rp.scrollView.height);
        this._scrollViewer.thickness = 0;
        this._scrollViewer.color = rp.scrollView.colors.background;
        this._scrollViewer.barColor = rp.scrollView.colors.bar;
        this._scrollViewer.hoverBarColor = rp.scrollView.colors.hoverBar;
        this._scrollViewer.pressedBarColor = rp.scrollView.colors.pressedBar;
        this._scrollViewer.horizontalBarPaddingInPixels = {
            left: this._mesh2d.m2px(rp.scrollView.horizontalBar.padding.left),
            right: this._mesh2d.m2px(rp.scrollView.horizontalBar.padding.right),
            top: this._mesh2d.m2px(rp.scrollView.horizontalBar.padding.top),
            bottom: this._mesh2d.m2px(rp.scrollView.horizontalBar.padding.bottom)
        };
        this._scrollViewer.barSizeInPixels = this._mesh2d.m2px(rp.scrollView.horizontalBar.size);
        this._scrollViewer.forceHorizontalBar = undefined;
        this._scrollViewer.verticalBar.isVisible = false;
        this._scrollViewer.horizontalValue = 0;
        backgroundPanel.addControl(this._scrollViewer);
        this._recommendedVideoClipsContainer = new StackPanel("videoClipMenuRecommendedScrollViewerContainer");
        this._recommendedVideoClipsContainer.isVertical = false;
        this._recommendedVideoClipsContainer.horizontalAlignment = Container.HORIZONTAL_ALIGNMENT_LEFT;
        this._recommendedVideoClipsContainer.verticalAlignment = Container.VERTICAL_ALIGNMENT_TOP;
        // this._recommendedVideoClipsContainer.widthInPixels = 10;
        this._recommendedVideoClipsContainer.heightInPixels = this._mesh2d.m2px(rp.scrollView.height);
        this._recommendedVideoClipsContainer.spacing = this._mesh2d.m2px(rp.item.spacing);
        this._scrollViewer.addControl(this._recommendedVideoClipsContainer);
    }
    show() {
        MeshUtils.setVisibility(this._mesh2d, this._calculateVisibility());
        this._scrollHandler.releaseThumbstickAxesChangedListener();
        this._scrollHandler.addThumbstickAxesChangedListener(false);
    }
    hide() {
        this._isFocused = false;
        this._scrollHandler.releaseThumbstickAxesChangedListener();
        MeshUtils.setVisibility(this._mesh2d, false);
    }
    outputVideoClip(videoClip) {
        this._videoClip = videoClip;
    }
    outputRecommendedVideoClips(videoClips) {
        this._recommendedVideoClipsContainer.clearControls();
        const addStartOrEndSpacing = () => {
            if (videoClips.pageItems.length === 0)
                return;
            const control = new Container("");
            control.widthInPixels = 1;
            control.heightInPixels = 1;
            this._recommendedVideoClipsContainer.addControl(control);
        };
        addStartOrEndSpacing();
        videoClips.pageItems.forEach((videoClip, index) => {
            const thumbnail = this._createRecommendedVideoClipControl(videoClip, index);
            this._recommendedVideoClipsContainer.addControl(thumbnail);
        });
        addStartOrEndSpacing();
        this._scrollViewer.horizontalValue = 0;
        this._hasRecommendedVideoClips = videoClips.pageItems.length > 0;
        MeshUtils.setVisibility(this._mesh2d, this._calculateVisibility());
    }
    _calculateVisibility() {
        // const result = this._hasRecommendedVideoClips && this._videoClip !== null &&
        //     (this._videoClip.isFree || this._videoClip.product?.isPurchased === true);
        // console.log(`++++ _calculateVisibility() => _hasRecommendedVideoClips: ${this._hasRecommendedVideoClips}, isFree: ${this._videoClip?.isFree}, isPurchased: ${this._videoClip?.product?.isPurchased}, result: ${result}`);
        // return result;
        return this._hasRecommendedVideoClips && this._videoClip !== null;
    }
    _createRecommendedVideoClipControl(videoClip, index) {
        const it = Env.videoClip.menu.recommendedVideosPanel.item;
        const rectangle = new Rectangle3D(`videoClipMenuRecommendedItem${index}`);
        rectangle.verticalAlignment = Rectangle3D.VERTICAL_ALIGNMENT_TOP;
        rectangle.widthInPixels = this._mesh2d.m2px(it.width);
        rectangle.heightInPixels = this._mesh2d.m2px(it.height);
        rectangle.cornerRadius = this._mesh2d.m2px(it.cornerRadius);
        rectangle.thickness = 0;
        rectangle.color = it.hover.color;
        const image = new Image3D(`videoClipMenuRecommendedItemImage${index}`, videoClip.coverImageUrl);
        rectangle.addControl(image);
        const unselectAllRectangles = () => {
            this._recommendedVideoClipsContainer.children.forEach(child => {
                if (child.thickness) {
                    const otherRectangle = child;
                    otherRectangle.thickness = 0;
                    otherRectangle.background = Env.videoClip.menu.background;
                }
                this._titleTextBlock.text = text.videoClip_recommended_title;
            });
        };
        const selectRectangle = (r, title) => {
            r.thickness = this._mesh2d.m2px(it.hover.thickness);
            r.background = it.hover.color;
            this._titleTextBlock.text = title;
        };
        image.onPointerEnterObservable.add(() => {
            unselectAllRectangles();
            selectRectangle(rectangle, videoClip.title);
        });
        image.onPointerOutObservable.add(() => {
            unselectAllRectangles();
        });
        image.onPointerClickObservable.add(async () => {
            await this._callbacks.openBroadcastAsync({
                modelNickname: videoClip.modelNickname,
                videoClip: { id: videoClip.id, productId: videoClip.product?.productId },
            });
            unselectAllRectangles();
        });
        return rectangle;
    }
}
